import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
    Config,
    isWidget,
} from '@ratehub/base-ui';
import { AffordabilityCalculator } from '@ratehub/calculators';

import PAGE_TEMPLATES from '../definitions/PageTemplates';
import MortgageSaveToProfileContainer from './MortgageSaveToProfileContainer';
import AdvertisingDisclosure from './AdvertisingDisclosure';


function MortgageAffordabilityCalculator({
    showAdDisclosure = true,
    className,
    ...otherProps
}) {
    const shouldShowSaveToProfileButton = Config.ENABLE_SAVE_TO_PROFILE_BUTTON && !isWidget();

    return (
        <section className={classNames('rh-max-width-75 rh-pt-0_5', className)}>
            <If condition={shouldShowSaveToProfileButton}>
                <MortgageSaveToProfileContainer dataName={DATA_NAME_SAVE_TO_PROFILE} />
            </If>

            <AffordabilityCalculator
                className="rh-mt-0 rh-mx-auto rh-mb-1"
                {...otherProps}
            />

            <If condition={showAdDisclosure}>
                <div className="rh-display-flex rh-justify-content-flex-end rh-my-1 rh-mx-0_5">
                    <AdvertisingDisclosure
                        size="extra-small"
                    />
                </div>
            </If>

            <If condition={shouldShowSaveToProfileButton}>
                <MortgageSaveToProfileContainer dataName={DATA_NAME_SAVE_TO_PROFILE} />
            </If>
        </section>
    );
}

MortgageAffordabilityCalculator.propTypes = {
    showAdDisclosure: PropTypes.bool,
    className: PropTypes.string,
};

const DATA_NAME_SAVE_TO_PROFILE = 'mtg-affordability-SaveToProfile';


MortgageAffordabilityCalculator.blockKey = 'rh/mortgage-affordability-calculator';
MortgageAffordabilityCalculator.requiresLayoutRow = true;
MortgageAffordabilityCalculator.supportedPageTypes = [ PAGE_TEMPLATES.calculatorsMtg ];

export default MortgageAffordabilityCalculator;
